import {
    REQUEST_BANK_STATEMENTS,
    RECEIVE_BANK_STATEMENTS,
    UPDATE_BANK_STATEMENTS,
    ERROR_BANK_STATEMENTS
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem, reloadDashboard} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters";

function request() {
    return {
        type: REQUEST_BANK_STATEMENTS
    };
}

export function receive(data) {
    return {
        type: RECEIVE_BANK_STATEMENTS,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_BANK_STATEMENTS,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_BANK_STATEMENTS,
        id,
        payload: data,
        updateType
    }
}

export function getBankStatements(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().bankStatements, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'bank-statements',
                params: prepareFilters(params, getState(), "bank-statements")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getBankStatement(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('bankStatement'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'bank-statements/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createBankStatement(data) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'POST',
                url: fetchUrl + 'bank-statements',
                data
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_created'))
                dispatch(update(res.data.data, false, 'create'))
                dispatch(reloadDashboard())
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateBankStatement(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('bankStatement'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'bank-statements/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                dispatch(reloadDashboard())
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteBankStatement(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'bank-statements/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                dispatch(reloadDashboard())
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}